import { NEW_GAME, ADD_CLICKED, CHECK_SET, SHUFFLE } from '../actions/cards';
import Immutable from "immutable";
import HistoryLogItem from "../component/History/historyLogItem";


const initialState = Immutable.Map({
  cardDeck: Immutable.fromJS(makeDeck()),
  cardsOut: Immutable.List(),
  cardsClickedOn: Immutable.List(),
  cardsUsed: Immutable.List(),

  playerOneCorrect: 0,
  playerOneErrors: 0,
  playerTwoCorrect: 0,
  playerTwoErrors: 0,

  historyLog: Immutable.List(),
})

// Creating the deck of cards for the game of set
function makeDeck() {
  let deck_arr = [];
  const number = ['1', '2', '3'];
  const color = ['purple', 'red', 'green'];
  const shape = ['diamond', 'squiggle', 'oval'];
  const shading = ['empty', 'shaded', 'solid'];

  number.forEach((number) => {
    color.forEach((color) => {
      shape.forEach((shape) => {
        shading.forEach((shading) => {
          deck_arr.push({ number: number, color: color, shape: shape, shading: shading, index: -1 });
        });
      });
    });
  });

  // shuffles cards in the deck
  let currentIndex = deck_arr.length;
  let temporaryValue;
  let randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex > 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = deck_arr[currentIndex];
    deck_arr[currentIndex] = deck_arr[randomIndex];
    deck_arr[randomIndex] = temporaryValue;
  }
  return deck_arr;
};


const card = (action) => {
  let { number, color, shape, shading, index } = action;
  return {
    number,
    color,
    shape,
    shading,
    index,
  }
}

const gameInfo = (state = initialState, action) => {

  switch (action.type) {
    // takes 12 random cards from the deck and puts into the cards out list
    case NEW_GAME: {
      return state.withMutations(s => {
        // reset all the card decks
        s.update('cardDeck', (cardDeck) => Immutable.fromJS(makeDeck()));
        s.update('cardsOut', (cardsOut) => cardsOut.clear());
        s.update('cardsClickedOn', (cardsClickedOn) => cardsClickedOn.clear());
        s.update('cardsUsed', (cardsUsed) => cardsUsed.clear());

        // push out 12 random cards to cards out
        for (let i = 0; i < 12; i++) {
          s.updateIn(['cardDeck', 0], (card) => card.set('index', i));
          const tempCard = s.getIn(['cardDeck', 0]);

          s.update('cardDeck', (cardDeck) => cardDeck.shift());
          s.update('cardsOut', (cardsOut) => cardsOut.push(tempCard));
        }

        // clear all the points
        s.set('playerOneCorrect', 0);
        s.set('playerOneErrors', 0);
        s.set('playerTwoCorrect', 0);
        s.set('playerTwoErrors', 0);

        let log = new HistoryLogItem("New Game has started", "log");
        s.update('historyLog', (historyLog) => historyLog.clear());
        s.update('historyLog', (historyLog) => historyLog.push(log));
        console.clear();
        console.log(JSON.stringify(s.get('historyLog')));

      });
    }
    case SHUFFLE:
      return state.withMutations(s => {
        s.update('cardsClickedOn', (cardsClickedOn) => cardsClickedOn.clear());

        let deck_arr = s.get('cardDeck').concat(s.get('cardsOut'));
        s.update('cardDeck', (cardDeck) => cardDeck.clear());
        s.update('cardsOut', (cardsOut) => cardsOut.clear());
        console.log(deck_arr.size);
        // shuffles cards in the deck
        let currentIndex = deck_arr.size;
        let temporaryValue;
        let randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex > 0) {
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
          // And swap it with the current element.
          temporaryValue = deck_arr[currentIndex];
          deck_arr[currentIndex] = deck_arr[randomIndex];
          deck_arr[randomIndex] = temporaryValue;
        }

        s.set('cardDeck', deck_arr);

        // push out 12 random cards to cards out
        for (let i = 0; i < 12; i++) {
          s.updateIn(['cardDeck', 0], (card) => card.set('index', i));
          const tempCard = s.getIn(['cardDeck', 0]);

          s.update('cardDeck', (cardDeck) => cardDeck.shift());
          s.update('cardsOut', (cardsOut) => cardsOut.push(tempCard));
        }

      });
    // adds the selected card into the clicked on list
    // checks to see if the card has already been clicked on (if so, removes from the clickedd on list)
    case ADD_CLICKED:
      return state.withMutations(s => {

        // recording which card has been clicked on (passed thru action)
        let tempCard = card(action);

        // get the list of cards that have been clicked on
        let cardsClickedOnList = s.get('cardsClickedOn');

        // check to see if this is an actual card and not just a default set card (only check if it is not a default card and is an acutal card with props)
        // the reason why I have it check the number prop is that when rendering, it will render the generic set card if one of the props is marked undefined
        // if one prop is undefined, it is a default set card
        if (tempCard.number !== undefined) {
          // determining if the card has been clicked on
          // if the card has already been clicked on and already exists in the clicked on list
          if (cardsClickedOnList.some(card => (card.color === tempCard.color && card.number === tempCard.number && card.shape === tempCard.shape && card.shading === tempCard.shading))) {
            cardsClickedOnList = cardsClickedOnList.pop(tempCard); // remove from the clicked on list
          }
          else {
            if (cardsClickedOnList.size < 3) {
              cardsClickedOnList = cardsClickedOnList.push(tempCard); // add to the clicked on list
            }
            else {
              alert("There can only be three cards in a set!");
            }
          }
        }

        s.set('cardsClickedOn', cardsClickedOnList);

      });
    // checks to see if there is a set with the three cards (len 3)
    case CHECK_SET:
      return state.withMutations(s => {

        // get the list of cards that have been clicked on
        let cardsClickedOnList = s.get('cardsClickedOn');

        // check if there is a set
        // first need to check if there are three cards
        if (cardsClickedOnList.size === 3) {
          let card1 = cardsClickedOnList.get(0);
          let card2 = cardsClickedOnList.get(1);
          let card3 = cardsClickedOnList.get(2);

          // set logic
          // all of the 3 cards must all have the same or different of the following categories:
          // numbers, colors, shapes, and shadings
          let message = "";
          let log = new HistoryLogItem(message, "log");
          let setFound = false;
          if ((card1.number === card2.number && card2.number === card3.number) || (card1.number !== card2.number && card2.number !== card3.number && card1.number !== card3.number)) {
            if ((card1.color === card2.color && card2.color === card3.color) || (card1.color !== card2.color && card2.color !== card3.color && card1.color !== card3.color)) {
              if ((card1.shape === card2.shape && card2.shape === card3.shape) || (card1.shape !== card2.shape && card2.shape !== card3.shape && card1.shape !== card3.shape)) {
                if ((card1.shading === card2.shading && card2.shading === card3.shading) || (card1.shading !== card2.shading && card2.shading !== card3.shading && card1.shading !== card3.shading)) {

                  log.addMessage('SET HAS BEEN FOUND WITH');
                  log.addDetail(`Card ${card1.number}, ${card1.color}, ${card1.shape}, ${card1.shading}`);
                  log.addDetail(`Card ${card2.number}, ${card2.color}, ${card2.shape}, ${card2.shading}`);
                  log.addDetail(`Card ${card3.number}, ${card3.color}, ${card3.shape}, ${card3.shading}`);
                  setFound = true;

                }
                else {
                  message = ("This is not a set because of the shading");
                  log = new HistoryLogItem(message, "log");
                }
              }
              else {
                message = ("This is not a set because of the shapes");
                log = new HistoryLogItem(message, "log");

              }
            }
            else {
              message = ("This is not a set because of the colors!");
              log = new HistoryLogItem(message, "log");

            }
          }
          else {
            message = ("This is not a set becasuse of the numbers!");
            log = new HistoryLogItem(message, "log");
          }
          s.update('historyLog', (historyLog) => historyLog.push(log));

          // console.log('history log in reducer', JSON.stringify(s.get('historyLog')));

          if (setFound) {
            // if there is a set, replace the three cards
            for (let i = 0; i < 3; i++) {
              let cardToBeReplaced = cardsClickedOnList.get(i);
              let indexOfOldCard = cardToBeReplaced.index;

              // to replace the card, we need to make sure that there are cards left in the deck
              // if there is a card(s) in the deck, then we replace the set cards with a card from the deck
              // if there are no more cards in the deck, we repalce the set cards with the generic set card
              if (s.get('cardDeck').size > 0) {
                let newCard = s.get('cardDeck').get(0); // get the new card from the deck
                s.update('cardDeck', (cardDeck) => cardDeck.shift()); // remove the top of the deck 

                // In here, we replace all the attributes of the card in the cards out list (which holds the info of all the cards being displayed)
                // with the attriubtes of the new card we obtained from the top of the card deck
                s.setIn(['cardsOut', indexOfOldCard], Immutable.Map({ 'number': newCard.get('number'), 'color': newCard.get('color'), 'shape': newCard.get('shape'), 'shading': newCard.get('shading'), 'index': indexOfOldCard }));

              }
              else {
                s.setIn(['cardsOut', indexOfOldCard], Immutable.Map({ 'number': undefined, 'color': undefined, 'shape': undefined, 'shading': undefined, 'index': indexOfOldCard }));

              }
            }

            // giving points to the player that found the set
            action.player === 1 ? s.set('playerOneCorrect', s.get('playerOneCorrect') + 1) : s.set('playerTwoCorrect', s.get('playerTwoCorrect') + 1);
          }
          else {
            // giving errors to the player that did not find the set
            action.player === 1 ? s.set('playerOneErrors', s.get('playerOneErrors') + 1) : s.set('playerTwoErrors', s.get('playerTwoErrors') + 1);
          }
          cardsClickedOnList = cardsClickedOnList.clear();
        }

        s.set('cardsClickedOn', cardsClickedOnList);


      })
    default:
      return state;
  }
}

export default gameInfo;